import { FC, ReactNode, MouseEvent, useMemo } from 'react';
import Loader from './Loader';

type Props = {
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: (event?:MouseEvent<HTMLButtonElement>) => void;
  size?: 'xsmall' | 'small' | 'default' | 'large';
  disableShadow?: boolean;
  children: ReactNode;
  loading?: boolean;
  style?: any;
}

export const Button:FC<Props> = ({
  className = '', type = 'button', disabled = false, onClick = () => null,
  size = 'default', disableShadow = false, loading = false, style = {},
  children
}) => {

  const classes:any = useMemo(() => ({
    xsmall: 'text-xs py-1 px-2 rounded',
    small: 'text-sm p-2 rounded-lg',
    default: 'text-base px-4 py-3 rounded-2xl'
  }), []);

  return (
    <button
      className={`
        ${classes[size]}
        bg-gray-200
        ${!disableShadow ? 'shadow-neu active:shadow-neu-inner hover:bg-gradient-to-br hover:from-[#ced0d4] hover:to-[#f5f7fb]' : ''}
        font-semibold
        uppercase
        ${className}
        ${disabled || loading ? 'pointer-events-none opacity-50 text-gray-200' : ''}
      `}
      style={style}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <Loader />}
      {children}
    </button>
  )
}

// export const ActionButton:FC<Props> = ({ children, ...otherProps }) => (
//   <div className="mb-4">
//     <Button
//       className="group w-full hover:bg-none bg-primary text-white flex items-center justify-center gap-3 relative overflow-hidden"
//       {...otherProps}
//     >
//       <span className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-30 transition-opacity duration-300 group-hover:opacity-0 pointer-events-none"></span>
//       <span className="relative">{children}</span>
//     </Button>
//   </div>
// );
